import React, { useState } from "react";
// ANT DESIGN COMPONENTS
import { Button, Collapse, Tooltip } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useSelector } from "react-redux";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputText from "../../../../components/form/FormInputText";
import FormInputNumber from "../../../../components/form/FormInputNumber";
// INTERFACES
import { RootState } from "../../../../../app/store";
import { CarNum2NameEntry } from "../../../../../interfaces/AdapterCdoOpc.interface";

interface CdoOpcCarNumberToNameProps {
  setCdoOpcCarNumberToName: (newValue: CarNum2NameEntry[]) => void;
  carNumbersToNames?: CarNum2NameEntry[];
}

export default function CdoOpcCarNumberToName({
  setCdoOpcCarNumberToName,
  carNumbersToNames = [],
}: CdoOpcCarNumberToNameProps) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");
  const { theme } = useSelector((state: RootState) => state.home);
  const { Panel } = Collapse;

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [carNumberToName, setCarNumberToName] = useState<CarNum2NameEntry>({
    key: 1,
    val: "",
  });

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChangeFormValue = (newValue: string | number, variableName: string) => {
    const copy = structuredClone(carNumberToName);
    if (variableName === "val" && typeof newValue === "string") {
      copy.val = newValue;
    } else if (variableName === "key" && typeof newValue === "number") {
      copy.key = newValue;
    }
    setCarNumberToName(copy);
  };

  const onClickAddNewCarNumberToName = () => {
    const copy = structuredClone(carNumbersToNames);
    copy.push(carNumberToName);
    setCarNumberToName({ key: 1, val: "" });
    setCdoOpcCarNumberToName(copy);
  };

  const onClickRemoveItem = (index: number) => {
    const copy = structuredClone(carNumbersToNames);
    copy.splice(index, 1);
    setCdoOpcCarNumberToName(copy);
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <Collapse>
        <Panel header={t("general.opcCarNumToName")} key="1">
          <div className="container">
            <div className={`drawer__box__${theme} row`}>
              <FormInputText
                inputValue={carNumberToName.val}
                inputLabelName={t("general.value")}
                inputOnChange={onChangeFormValue}
                inputVariableName="val"
                isRequired
                disabledInput={false}
              />
              <FormInputNumber
                inputValue={carNumberToName.key}
                inputOnChange={onChangeFormValue}
                inputLabelName="Key"
                inputVariableName="key"
              />
              <div className="col-md-12 mt-3">
                <div className="generalStyles__flex">
                  <div className="generalStyles__inputFlexNameLarge">
                    <span className="generalStyles__inputFlexRequired">*</span>
                    <span className="drawer__text">{t("general.preview")}</span>
                  </div>
                  <div className="generalStyles__width100">
                    <div>
                      {carNumbersToNames.map((item: CarNum2NameEntry, itemIndex: number) => (
                        <div
                          key={itemIndex}
                          style={{
                            backgroundColor: "#1f1f1f",
                            borderRadius: "5px",
                            fontSize: "10px",
                            padding: "10px",
                            marginTop: "10px",
                          }}
                          className="generalStyles__spaceBetween"
                        >
                          <div>
                            <div>
                              <span className="generalStyles__info">Key:</span>{" "}
                              <span>{item.key}</span>
                            </div>
                            <div>
                              <span className="generalStyles__info">Val:</span>{" "}
                              <span>{item.val}</span>
                            </div>
                          </div>
                          <div className="generalStyles__flexCenter" style={{ width: "50px" }}>
                            <Tooltip title={t("general.delete")}>
                              <Button
                                onClick={() => {
                                  onClickRemoveItem(itemIndex);
                                }}
                                className="buttonStyle__29"
                                shape="circle"
                                icon={<FontAwesomeIcon icon={faTrash} />}
                              />
                            </Tooltip>
                          </div>{" "}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <div className="generalStyles__flex">
                  <div className="generalStyles__inputFlexNameLarge">
                    <span className="generalStyles__inputFlexRequired" />
                  </div>
                  <div className="generalStyles__width100">
                    <Button
                      disabled={carNumberToName.val === ""}
                      onClick={onClickAddNewCarNumberToName}
                      className={`generalStyles__width100 ${
                        carNumberToName.val === "" ? "" : "buttonStyle__28"
                      }`}
                    >
                      <FontAwesomeIcon icon={faPlus} className="generalStyles__mrFix" />
                      {t("general.add")}
                    </Button>
                  </div>
                  <div className="generalStyles__infoTooltipIconBlank" />
                </div>
              </div>
            </div>
          </div>
        </Panel>
      </Collapse>
      <br />
    </div>
  );
}
